<template>
<section class="premium-section">
<h2 class="section-title">Mudra Creator Reward Accounting System</h2>

<p>
Mudra is designed as a creator-first ecosystem that rewards original written content while maintaining long-term sustainability for the platform and its community.
</p>

<p>
When creators publish original content that meets the platform’s originality and quality standards, the system calculates rewards based on the predefined reward model established by the platform.
</p>

<p>
These rewards are displayed within the creator dashboard as <strong>Estimated MDR Rewards</strong>. This balance represents the total rewards accumulated through verified content contributions.
</p>

<p>
During the active reward phase of the platform, rewards are tracked within Mudra’s internal accounting system rather than being immediately distributed on the blockchain.
</p>

<p>
This model allows the platform to efficiently track creator rewards while minimizing unnecessary blockchain transactions.
</p>

</section>
</template>